import { useState } from "react";
import {
  passwordValidation,
  confirmPasswordValidator,
} from "../../components/validation/Validation";
const touchErrors = (errorss) => {
  return Object.entries(errorss).reduce((acc, [field, fieldError]) => {
    acc[field] = {
      ...fieldError,
      dirty: true,
    };
    return acc;
  }, {});
};
export const UsePasswordformvalidation = (formm) => {
  const [errorss, setErrorss] = useState({
    password: {
      dirty: false,
      error: false,
      message: "",
    },
    confirmPassword: {
      dirty: false,
      error: false,
      message: "",
    },
  });

  const validateFormm = ({ formm, field, errorss, forceTouchErrors = false }) => {
    let isValid = true;

    // Create a deep copy of the errors
    let nextErrors = JSON.parse(JSON.stringify(errorss));

    // Force validate all the fields
    if (forceTouchErrors) {
      nextErrors = touchErrors(errorss);
    }

    const {
      password,
      confirmPassword,
    } = formm;

    if (nextErrors.password.dirty && (field ? field === "password" : true)) {
      const passwordMessage = passwordValidation(password, formm);
      nextErrors.password.error = !!passwordMessage;
      nextErrors.password.message = passwordMessage;
      if (!!passwordMessage) isValid = false;
    }
    if (
      nextErrors.confirmPassword.dirty &&
      (field ? field === "confirmPassword" : true)
    ) {
      const confirmPasswordMessage = confirmPasswordValidator(
        confirmPassword,
        formm
      );
      nextErrors.confirmPassword.error = !!confirmPasswordMessage;
      nextErrors.confirmPassword.message = confirmPasswordMessage;
      if (!!confirmPasswordMessage) isValid = false;
    }
    setErrorss(nextErrors);

    return {
      isValid,
      errorss: nextErrors,
    };
  };

  const onBlurFieldd = (e) => {
    const field = e.target.name;
    const fieldError = errorss[field];
    if (fieldError.dirty) return;

    const updatedErrors = {
      ...errorss,
      [field]: {
        ...errorss[field],
        dirty: true,
      },
    };

    validateFormm({ formm, field, errorss: updatedErrors });
  };
  return {
    validateFormm,
    onBlurFieldd,
    errorss,
  };
};
